import adAccountCRUDActions from '../actions/AdAccountCRUDActions';
import Actions from '../actions/actions';
import { retrieved, setBusy, setUnBusy } from './common/commonReducers';
import { AdAccountsState } from '../interfaces/adAccounts';
import AdAccountModel from '../model/AdAccountModel';
import _ from 'lodash';

const initialState: AdAccountsState = {
  busy: false,
  entities: [],
  next: '',
};

const checkIfIdUnique = (prevItem: AdAccountModel, nextItem: AdAccountModel) =>
  prevItem.id === nextItem.id;

const unionUniqueById = (
  prevEntities: AdAccountModel[],
  nextEntities: AdAccountModel[],
) => {
  return _.unionWith(prevEntities, nextEntities, checkIfIdUnique);
};

const retrievedAll = (state: AdAccountsState, action): AdAccountsState => {
  const { entities: nextEntities, next } = action;
  const { entities: prevEntities } = state;

  return {
    ...state,
    next,
    entities: unionUniqueById(prevEntities, nextEntities),
    busy: false,
  };
};

export default function adInsight(
  state: AdAccountsState = initialState,
  action,
): AdAccountsState {
  switch (action.type) {
    case adAccountCRUDActions.retrievedAction:
      return retrieved(state, action);
    case adAccountCRUDActions.busyAction:
      return setBusy(state);
    case adAccountCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case adAccountCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
